import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const setChosenSchedule = api((id, type, schedule_id) =>
    mutate(
        gql`
            mutation SetChosenSchedule($id: String!, $type: String!, $schedule_id: String) {
                setChosenSchedule(id: $id, type: $type, schedule_id: $schedule_id)
            }
        `,
        { id, type, schedule_id },
        { returns: "setChosenSchedule" }
    )
)
